// Browser/Client Implementation (No-op)
class BrowserMetricsRegistry {
    constructor() {
        this.metrics = new Map();
    }

    createCounter() {
        return { inc: () => { } };
    }

    createHistogram() {
        return { observe: () => { } };
    }

    get() {
        // Return dummy metric object
        return { inc: () => { }, observe: () => { } };
    }

    async getMetrics() { return ''; }

    contentType() { return 'text/plain'; }
}

export const Metrics = new BrowserMetricsRegistry();
export default Metrics;
